import { Chip } from '@mui/material';
import { VerifiedUser } from '@mui/icons-material';
import { status as statusColors } from '../../theme/colors';

/** The one badge a buyer is being asked to trust — same wording and colour everywhere it appears. */
export default function VerifiedChip(props) {
  return (
    <Chip
      size="small"
      icon={<VerifiedUser sx={{ color: `${statusColors.success} !important` }} />}
      label="Eqaya Verified"
      {...props}
      sx={{ color: statusColors.success, bgcolor: statusColors.successBg, fontWeight: 600, ...props.sx }}
    />
  );
}
